(ns kyber.kyber-db.assessment)

(defn ->ident-key
  [{activity-uuid :activity/uuid}]
  (str "activity-" activity-uuid "_assessment"))

(def model
  {:ident-key ->ident-key

   :refs
   #:assessment
   {:questions
    {:model :question-context
     :cardinality :many}}

   :schema
   #:assessment
   {:feedback-display-strategy {:doc ""}
    :show-answers-and-feedback-when-passed-or-exhausted? {:doc ""}
    :settings-confirmed? {:doc ""}
    :messaging-confirmed? {:doc ""}
    :max-attempts {:doc ""}
    :pass-percent {:doc ""}
    :pre-test-pass-percent {:doc ""}
    :results-display-strategy {:doc ""}
    :can-test-out? {:doc ""}}})
